/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cursor_Explore_WorkInputs */

const en_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore work`)
};

const ar_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف الأعمال`)
};

const bn_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজগুলো দেখুন`)
};

const de_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie die Arbeit`)
};

const es_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar trabajo`)
};

const fr_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer le travail`)
};

const pt_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar trabalho`)
};

const zh_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索工作`)
};

const tr_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşi keşfedin`)
};

const ru_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смотреть работу`)
};

const pl_cursor_explore_work = /** @type {(inputs: Cursor_Explore_WorkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj pracę`)
};

/**
* | output |
* | --- |
* | "Explore work" |
*
* @param {Cursor_Explore_WorkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cursor_explore_work = /** @type {((inputs?: Cursor_Explore_WorkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cursor_Explore_WorkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cursor_explore_work(inputs)
	if (locale === "bn") return bn_cursor_explore_work(inputs)
	if (locale === "de") return de_cursor_explore_work(inputs)
	if (locale === "es") return es_cursor_explore_work(inputs)
	if (locale === "fr") return fr_cursor_explore_work(inputs)
	if (locale === "pt") return pt_cursor_explore_work(inputs)
	if (locale === "zh") return zh_cursor_explore_work(inputs)
	if (locale === "tr") return tr_cursor_explore_work(inputs)
	if (locale === "ru") return ru_cursor_explore_work(inputs)
	if (locale === "pl") return pl_cursor_explore_work(inputs)
	return en_cursor_explore_work(inputs)
});